import React, { useState, useEffect } from "react";
import { Card, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import useApi from "../../../../utils/api-manager/Helper/useApi"; 

const MostSoldProducts = () => {
  const [products, setProducts] = useState([]);
  const [weeklyProducts, setWeeklyProducts] = useState([]); 
  const [loading, setLoading] = useState(true); 
  const [, setError] = useState(null); 
  const { Post } = useApi(); 

  useEffect(() => {
    fetchTopSellingProducts(); 
  }, []); 

  const fetchTopSellingProducts = async () => {
    try {
      setLoading(true); 
      const currentYear = new Date().getFullYear();
      const startDate = `${currentYear}-01-01`;
      const endDate = `${currentYear}-12-31`;

      const response = await Post("topSellingProducts", { start_date: startDate, end_date: endDate });
      const { data } = response; 
      setProducts(data.top_5_products_date_range || []); 
      setWeeklyProducts(data.top_5_products_this_week || []); 
    } catch (error) {
      setError("Failed to fetch data: " + error.message);
    } finally {
      setLoading(false); 
    }
  };
  

  return (
    <div style={{ display: "flex", gap: "15px" }}>
      <ProductCard title="Most Sold Products" data={products} loading={loading} />
      <ProductCard title="Most Sold Products This Week" data={weeklyProducts} loading={loading} />
    </div>
  );
};

const ProductCard = ({ title, data, loading }) => {
  const isDataEmpty = data.length === 0;

  return (
    <Card
      style={{
        width: "300px",
        height: "300px",
        padding: "5px",
        backgroundColor: "#FFFFFF",
        border: "1px solid #EBEAF2",
        boxShadow: "0px 2px 8px rgba(6, 12, 34, 0.0392157)",
        borderRadius: "40px",
      }}
    >
   
      {!isDataEmpty && !loading && (
        <Typography
          variant="h6"
          style={{
            textAlign: "center",
            fontWeight: "bold",
            fontSize: "16px", 
            marginTop: "10px", 
          }}
        >
          {title}
        </Typography>
      )}

      {loading ? (
        <div style={{
          fontSize: '16px',
          color: '#999',
          textAlign: 'center',
          fontStyle: 'italic',
        }}>Loading...</div>
      ) : isDataEmpty ? (
        <div style={{
          fontSize: '16px',
          color: '#999',
          textAlign: 'center',
          fontStyle: 'italic',
        }}>No data available</div>
      ) : (
        <TableContainer style={{ marginTop: "20px" }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell
                  style={{
                    fontWeight: "bold",
                    fontSize: "14px", 
                    padding: "8px", 
                    textAlign: 'left',
                  }}
                >
                  Product Name
                </TableCell>
                <TableCell
                  style={{
                    fontWeight: "bold",
                    fontSize: "14px", 
                    padding: "8px", 
                    textAlign: 'right',
                  }}
                >
                  Sales
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.map((item, index) => (
                <TableRow key={index}>
                  <TableCell style={{ fontSize: "14px", padding: "5px", textAlign: 'left' }}>
                    {item.product_name}
                  </TableCell>
                  <TableCell style={{ fontSize: "14px", padding: "5px", textAlign: 'right' }}>
                    {item.total_sales ? item.total_sales.toLocaleString() : "0"} 
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Card>
  );
};


export default MostSoldProducts;
